//import logo from './logo.svg';
import { useState } from 'react'
import { useSelector } from 'react-redux'
import Navigation from './Navigation/Navigation'
import Setting from './Navigation/Setting/Setting'
import PhoneButtons from './Navigation/PhoneButtons/PhoneButtons'
import Modal from './Navigation/PhoneButtons/Modal'

import Voittaja_Myyja from './images/animations/Voittaja_Myyja.gif'
import Voittaja_Asiakas from './images/animations/Voittaja_Asiakas.gif'

import './App.css'
import { useAudios } from './assets/useAudios'
import GdprFooter from './Components/GDPRFooter/GdprFooter'

const App = () => {
  const [allowScroll, setAllowScroll] = useState(false)
  const [overRide, setOverRide] = useState(false)
  const winner = useSelector(state => state.winner)
  const role = useSelector(state => state.role)
  const audio = useAudios()

  //modal stuff
  const [showModal, setShowModal] = useState(false);

  const playAgain = () => {
    window.location.reload()
  }

  const winnerText = () => {
    if (winner === 'player') {
      if (role === 'seller') {
        return 'Teit kaupat, hienoa!'
      }

      return 'Onnittelut, et ostanut mitään!'
    }

    if (winner === 'opponent') {
      if (role === 'seller') {
        return 'Pahus. Nyt ei tullut kauppoja...'
      }

      return 'Voi ei, sorruit taas tilaamaan turhuuksia!'
    }
  }

  //Winner animation handler block
  if (winner === 'player') {

    audio.setAndPlay('loppumusiikki_voitto', true)
    if (role === 'seller') {
      return (
        <div>
          <button className='play-again-button' onClick={() => playAgain()}>Pelaa uudelleen</button>
          <div className='winning-text'>{winnerText()}</div>
          <img className='winner-animation' src={Voittaja_Myyja} alt='Myyjä voittaa' />
        </div>
      )
    }

    return (
      <div>
        <button className='play-again-button' onClick={() => playAgain()}>Pelaa uudelleen</button>
        <div className='winning-text'>{winnerText()}</div>
        <img className='winner-animation' src={Voittaja_Asiakas} alt='Asiakas voittaa' />
      </div>
    )
  }

  if (winner === 'opponent') {
    audio.setAndPlay('loppumusiikki_tappio', true)
    if (role === 'seller') {
      return (
        <div>
          <button className='play-again-button' onClick={() => playAgain()}>Pelaa uudelleen</button>
          <div className='winning-text'>{winnerText()}</div>
          <img className='winner-animation' src={Voittaja_Asiakas} alt='Asiakas voittaa' />
        </div>
      )
    }
    return (
      <div>
        <button className='play-again-button' onClick={() => playAgain()}>Pelaa uudelleen</button>
        <div className='winning-text'>{winnerText()}</div>
        <img className='winner-animation' src={Voittaja_Myyja} alt='Myyjä voittaa' />
      </div>
    )
  }
  //-----------------------

  return (
    <div>
      <GdprFooter />
      <Modal showModal={showModal} setShowModal={setShowModal} />
      <div className='flex'>
        <div className={`image second-level game-screen ${allowScroll ? 'allow-scroll' : ''}`}> {/**PELIRUUTU */}
          <Navigation setAllowScroll={setAllowScroll} overRide={overRide} setOverRide={setOverRide} />
          <PhoneButtons setPage={setOverRide} showModal={showModal} setShowModal={setShowModal} />
        </div>
      </div>

      <Setting /> {/*taustakuva yms. sen mukaan mikä rooli / laite */}
    </div>
  )
}

export default App;
